import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "./Privacy.css"
import "aos/dist/aos.css";
import Header from "./Header";
import Footer from "./Footer";

const Privacy = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            {/* <!-- no header, just hero with floating badge --> */}
            <section className="privacy-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-eye"></i> ASK JEEVES IP · O'HANLON PATENT INNOVATION
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">Your data, your invention,<br />our commitment</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">How we protect your intellectual property and personal information under the O'Hanlon standard</p>
                    </div>
                </div>
            </section>
            <div className="content-container">
                <div className="privacy-card" data-aos="fade-up">
                    <p
                        style={{
                            fontSize: "1.2rem",
                            borderLeft: "4px solid #54A6E9",
                            paddingLeft: "1.5rem"
                        }}
                    >
                        <i
                            className="fa-regular fa-calendar-circle-check"
                            style={{ color: "#1D3A90" }}
                        ></i>{" "}
                        <strong>Effective:</strong> March 1, 2026
                    </p>
                    <p>
                        This Privacy Policy describes how Ask Jeeves IP ("we", "us", "our")
                        collects, uses, and shares your personal information when you use our
                        platform, including the O'Hanlon-powered patent drafting tools and
                        related services. Protecting your intellectual property and personal
                        data is at the core of our O'Hanlon standard.
                    </p>

                    <h2>
                        <i className="fa-regular fa-database"></i> 1. Information We Collect
                    </h2>

                    <h3>1.1 Information you provide</h3>

                    <ul>
                        <li>
                            <span className="data-badge">account</span> Name, email, company name,
                            billing info (processed securely via PCI-compliant partners).
                        </li>

                        <li>
                            <span className="data-badge">invention data</span> Invention
                            descriptions, technical drawings, prior art searches, drafts, and
                            communications with our patent attorneys – all treated as
                            confidential.
                        </li>

                        <li>
                            <span className="data-badge">communications</span> When you contact
                            support or participate in surveys.
                        </li>
                    </ul>

                    <h3>1.2 Automatic information</h3>

                    <ul>
                        <li>
                            Usage data (features used, time spent, clicks) to improve our AI
                            models and O'Hanlon workflows.
                        </li>
                        <li>Device and browser data, IP address, referrer.</li>
                        <li>Cookies and similar tracking (see section 4).</li>
                    </ul>

                    <h2>
                        <i className="fa-regular fa-chart-line"></i> 2. How We Use Your
                        Information
                    </h2>

                    <ul>
                        <li>
                            Provide, maintain, and improve the AI drafting and legal review
                            services.
                        </li>
                        <li>
                            Analyze and refine O'Hanlon-patented algorithms to increase drafting
                            accuracy.
                        </li>
                        <li>
                            Communicate with you about updates, security alerts, and patent
                            insights.
                        </li>
                        <li>Ensure legal compliance and protect against misuse.</li>
                    </ul>

                    <div className="privacy-emphasis" data-aos="zoom-in">
                        <i className="fa-regular fa-lightbulb"></i>{" "}
                        <strong>O'Hanlon confidentiality pledge:</strong> Your invention details
                        are never used to train models for public use without strict
                        anonymization. We maintain attorney-client privilege where applicable
                        and adhere to the O'Hanlon framework of data minimization.
                    </div>

                    <h2>
                        <i className="fa-regular fa-share-nodes"></i> 3. Sharing of Information
                    </h2>

                    <p>We do not sell your personal information. We may share data with:</p>

                    <ul>
                        <li>
                            <strong>O'Hanlon partner attorneys:</strong> when you request legal
                            review, selected patent practitioners receive your drafts under NDA.
                        </li>

                        <li>
                            <strong>Service providers:</strong> hosting (AWS), analytics, customer
                            support – bound by data protection terms.
                        </li>

                        <li>
                            <strong>Legal authorities:</strong> if required by law, court order, or
                            to protect our rights.
                        </li>

                        <li>
                            <strong>Business transfers:</strong> in case of merger or acquisition,
                            with notice to you.
                        </li>
                    </ul>

                    <h2>
                        <i className="fa-regular fa-cookie"></i> 4. Cookies and Tracking
                    </h2>

                    <p>
                        We use essential cookies for authentication and security. Optional
                        analytics cookies help us improve. You can manage preferences in your
                        browser. Full details in our Cookie Notice (available upon request).
                    </p>

                    <h2>
                        <i className="fa-regular fa-shield"></i> 5. Data Security
                    </h2>

                    <p>
                        We implement industry-standard encryption (TLS 1.3), access controls,
                        and regular audits. The O'Hanlon patent framework includes additional
                        proprietary security layers for invention data. Despite safeguards, no
                        method of transmission is 100% secure.
                    </p>

                    <h2>
                        <i className="fa-regular fa-clock"></i> 6. Data Retention
                    </h2>

                    <p>
                        We retain your account information as long as your account is active.
                        Invention drafts are retained for the period necessary to provide
                        services, comply with legal obligations, or resolve disputes. You may
                        request deletion of your data – subject to backup and legal holds.
                    </p>

                    <h2>
                        <i className="fa-regular fa-user-check"></i> 7. Your Rights
                    </h2>

                    <p>
                        Depending on your location, you may have rights to access, correct,
                        delete, or export your personal data. To exercise them, contact
                        privacy@askjeevesip.tech. We will respond within 30 days.
                    </p>

                    <h2>
                        <i className="fa-regular fa-globe"></i> 8. International Transfers
                    </h2>

                    <p>
                        If you use our services from outside the U.S., your data may be
                        transferred to and processed in the United States. We use Standard
                        Contractual Clauses and other safeguards to protect cross-border data
                        flows.
                    </p>

                    <h2>
                        <i className="fa-regular fa-child"></i> 9. Children's Privacy
                    </h2>

                    <p>
                        The Services are not directed to individuals under 18. We do not
                        knowingly collect data from minors. If we learn we have inadvertently
                        done so, we will delete it.
                    </p>

                    <h2>
                        <i className="fa-regular fa-pen-to-square"></i> 10. Changes to this
                        Policy
                    </h2>

                    <p>
                        We may update this Privacy Policy to reflect changes in our practices or
                        legal requirements. We will notify you by email or prominent notice
                        within the platform.
                    </p>

                    <h2>
                        <i className="fa-regular fa-envelope"></i> 11. Contact Us
                    </h2>

                    <p>
                        <i
                            className="fa-regular fa-envelope"
                            style={{ color: "#1D3A90" }}
                        ></i>{" "}
                        Privacy Questions: <strong>privacy@askjeevesip.tech</strong>
                        <br />
                        or write: Ask Jeeves IP (Attn: Privacy), 1 Innovation Way, Wilmington,
                        DE 19801.
                    </p>

                    <hr
                        style={{
                            margin: "3rem 0",
                            border: "1px solid #e5ecf5"
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "2rem",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <div>
                            <i
                                className="fa-regular fa-file-lines"
                                style={{ color: "#1D3A90" }}
                            ></i>{" "}
                            <strong>O'Hanlon Patent Innovation</strong> – data you can trust.
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Privacy